import { useCallback, useState } from 'react';
import SimpleDrawDlg from '../components/SimpleDrawDlg/SimpleDrawDlg';

export const useClipboard = (manualCopyMessage?: string) => {
  const [copiedText, setCopiedText] = useState<string | null>(null);
  const [manualText, setManualText] = useState<string | null>(null);

  const copy = useCallback(
    async (text: string) => {
      const fallbackCopy = () => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        textarea.style.top = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (!successful) {
          throw new Error('copy failed');
        }
      };

      const manualCopy = () => {
        if (manualCopyMessage) {
          setManualText(text);
        }
      };

      try {
        if (navigator?.clipboard?.writeText) {
          await new Promise<void>((resolve, reject) =>
            setTimeout(() => {
              navigator.clipboard.writeText(text).then(resolve).catch(reject);
            }, 0)
          );
        } else {
          fallbackCopy();
        }
        setCopiedText(text);
        return true;
      } catch {
        try {
          fallbackCopy();
          setCopiedText(text);
          return true;
        } catch {
          manualCopy();
          setCopiedText(null);
          return false;
        }
      }
    },
    [manualCopyMessage]
  );

  const manualDialog = manualCopyMessage ? (
    <SimpleDrawDlg
      open={manualText !== null}
      handleClose={() => setManualText(null)}
      maxWidth="xs"
      fullWidth
    >
      <div style={{ padding: 16 }}>
        <p>{manualCopyMessage}</p>
        <input
          style={{ width: '100%', marginTop: 8 }}
          readOnly
          value={manualText ?? ''}
          onFocus={(e) => e.currentTarget.select()}
        />
      </div>
    </SimpleDrawDlg>
  ) : null;

  return [copiedText, copy, manualDialog] as const;
};
